import { ReactComponent as ErrorIcon } from 'icons/error.svg';
import PropTypes from 'prop-types';

export const ErrorComponent = ({ children = null, className }) => {
  return (
    <div
      className={['textAlign-center paddingBottom-xxxxl', className]
        .filter(Boolean)
        .join(' ')}
    >
      <ErrorIcon className="marginBottom-lg marginTop-xxxxl" />
      {children}
    </div>
  );
};

ErrorComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
